import React from 'react'
import Select from './Select'

export default class SelectProvider2 extends React.Component {
    state = {provider: '', providers: []}

    handleChange = provider => {
        const form = document.getElementById("formWithSelectProvider")
        const input = document.getElementById("provider_id")
        if(input) input.value = provider
        form && form.submit()
    }

    render() {
        return (
            <div style={{display: 'inline-block', width: '380px'}}>
                <Select
                    selectedOption={this.props.selectedOption}
                    carModels={this.props.providers}
                    handleChange={this.handleChange}
                    placeholder={this.props.placeholder}
                />
            </div>
        )
    }
}